import axios from 'axios';
const apiUrl = process.env.PROXY_URL;

export async function getDepartmentPdfExport(
  departmentSlug: string
): Promise<Blob> {
  const subPath = 'api/agendamento-middleware/v1/service-charter/pdf';

  const response = await axios.get(`${apiUrl}/${subPath}/${departmentSlug}`, {
    headers: {
      accept: 'application/pdf',
    },
    responseType: 'arraybuffer',
  });

  return new Blob([response.data], { type: 'application/pdf' });
}
